"use strict";
/**
 * @license
 * Copyright 2018 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
Object.defineProperty(exports, "__esModule", { value: true });
/** Shared implementation of the split kernel across WebGL and CPU. */
function split(x, sizeSplits, axis) {
    var begin = new Array(x.rank).fill(0);
    var size = x.shape.slice();
    return sizeSplits.map(function (s) {
        size[axis] = s;
        var slice = x.slice(begin, size);
        begin[axis] += s;
        return slice;
    });
}
exports.split = split;
//# sourceMappingURL=split_shared.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@tensorflow/tfjs-core/dist/backends/split_shared.js
 ** module id = 475
 ** module chunks = 0
 **/